const DEFAULT_API_URL =
  process.env.NODE_ENV === "development"
    ? "http://127.0.0.1:6868/api/hospitalsxzz"
    : "https://cabackend.xinshu.pro/api/hospitalsxzz";

const DEFAULT_FILE_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://127.0.0.1:6868"
    : "https://cabackend.xinshu.pro";

export const API_URL = (process.env.VUE_APP_API_URL || DEFAULT_API_URL).replace(
  /\/$/,
  ""
);

export const FILE_BASE_URL = (
  process.env.VUE_APP_FILE_BASE_URL || DEFAULT_FILE_BASE_URL
).replace(/\/$/, "");
